import { render } from "./UserTestView.vue?vue&type=template&id=7c42ff7b&scoped=true"
import script from "./UserTestView.vue?vue&type=script&lang=js"
export * from "./UserTestView.vue?vue&type=script&lang=js"

import "./UserTestView.vue?vue&type=style&index=0&id=7c42ff7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c42ff7b"]])

export default __exports__